import React, { useEffect, useRef, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Footer from '../Footer';
import { toast } from 'react-toastify';

import axios from 'axios';
import config from '../../function/config';
import Usernav from '../UserHome/Usernav';
import AdminNav from '../Admin/AdminHome/AdminNav';
import HomeNav from '../Navbars/HomeNav';
import NewAdminNav from '../Admin/AdminHome/NewAdminNav';
import NewHomeNav from '../Navbars/NewHomeNav';
import NewFooter from '../NewFooter';

export default function RegisterSupplyEquipments() {

  
const [isScrolled, setIsScrolled] = useState(false);
 useEffect(() => {
        const handleScroll = () => {
          setIsScrolled(window.scrollY > 50); // Adjust the value to when you want the effect
        };
    
        window.addEventListener('scroll', handleScroll);
    
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, []);
      
  // Scroll to the top
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
      
        
        const navigate = useNavigate()
        
          

          const [formType, setFormType] = useState("sale"); // Default to "sale"
          const [loading,setLoading] = useState(false)
          const[Title,setTitle] = useState('')
          const[vesselType,setvesselType] = useState('')
          const[ShortDescription,setShortDescription] = useState('')
          const[Flag,setFlag] = useState('')
          const[YearBuilt,setYearBuilt] = useState('')
          const[Capacity,setCapacity] = useState('')
          const[LOA,setLOA] = useState('')
          const[Class,setClass] = useState('')
          const[GRTNRT,setGRTNRT] = useState('')
          const[Teu,setTeu] = useState('')
          const[Price,setPrice] = useState('')
          const[MainEngine,setMainEngine] = useState('')
          const[DWT,setDWT] = useState('')

          const[Email,setEmail] = useState('')
          const[MobileNO,setMobileNO] = useState('')
          const[BriefDescription,setBriefDescription] = useState('')
          const [images, setImages] = useState([]);
          const [ThumbnailImage, setThumbnailImage] = useState("");
          const [Image,setImage] = useState('')
          const [Nationality,setNationality] = useState('')
          const [BuyAsScrap,setBuyAsScrap] = useState('')
          const [From,setFrom] = useState('')
          const [To,setTo] = useState('')
          const [InspectionCountry,setInspectionCountry] = useState('')

          const [Category,setCategory] = useState('')
          const [Subject,setSubject] = useState('')


            const [allCategory, setallCategory] = useState([]);
              const [allSubCategory, setallSubCategory] = useState([]);
               const [selectedCategory, setSelectedCategory] = useState(""); // Track selected main category
                const [filteredSubCategories, setFilteredSubCategories] = useState([]);
          

          

          const [count,setCount] = useState(0)

           useEffect(() => {
  async function fetchData() {
    try {
      const res1 = await axios.get(
        `${config.base_url}/api/HappyMarineShipping/viewSubCategory`,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (res1.data.status === 200) {
        console.log(res1);
        setallSubCategory(res1.data.data.filter(eq=> eq.category === 3));
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  }
  fetchData();
}, [config.base_url, count]);


         const [selectedImages, setSelectedImages] = useState([]); // Array of { file, preview }
         
        const handleImageChange = (e) => {
  const files = Array.from(e.target.files);

  // Limit to 3 images max
  if (files.length + selectedImages.length > 3) {
    toast.error("You can only upload up to 3 images.");
    return;
  }

  const newFiles = files.map((file) => {
    file.preview = URL.createObjectURL(file);
    return file;
  });

  setSelectedImages((prev) => [...prev, ...newFiles]);
};
         
         const removeImage = (index) => {
  const updatedImages = [...selectedImages];
  updatedImages.splice(index, 1);
  setSelectedImages(updatedImages);
};

 const [user, setUser] = useState(null);
  const token = localStorage.getItem("token");
  useEffect(() => {
          if (!token) {
            navigate('/login'); // login page
          }
        }, [token, navigate]);

  useEffect(() => {
    async function fetchdata() {
      try {
        const res2 = await axios.get(
          `${config.base_url}/api/HappyMarineShipping/viewusers`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Token ${token}`,
            },
          }
        );
        console.log("API response:", res2.data);
        if (res2.data.status === 200) {
          console.log("User:", res2);
          setUser(res2.data.data);
        } else {
          console.log(res2);
        }
      } catch (error) {
        console.log(error);
      }
    }
    fetchdata();
  }, [token]);

  const userId = localStorage.getItem("userId");


        

      const handleSubmitEqupment = async (e, id) => {
  e.preventDefault();
  setLoading(true);

  const formData = new FormData();
  if (userId) {
  formData.append("user", userId);
}
  formData.append("category", Category);
  formData.append("subject", Subject);
  formData.append("email", Email);
  formData.append("phone", MobileNO);
  formData.append("brief_description", BriefDescription);

  // Append images (up to 3)
  selectedImages.forEach((imageFile) => {
    formData.append("images", imageFile);  // Key must match Django view (request.FILES.getlist('images'))
  });

  try {
    const response = await axios.post(
      `${config.base_url}/api/HappyMarineShipping/RegShipForEquipments`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
           Authorization: `Token ${token}`,
        },
      }
    );

    if (response.data.status === 200) {
      navigate('/regShip')
      setLoading(false);
      toast.success("Registered Successfully!", {
        autoClose: 1500,
        position: "top-right",
      });

      // Clear fields
      setCount(id);
      setCategory("");
      setSubject("");
      setEmail("");
      setMobileNO("");
      setBriefDescription("");
      setSelectedImages([]);
    } else {
      setLoading(false);
      toast.error("Fill the required Fields", {
        autoClose: 1500,
        position: "top-right",
      });
    }
  } catch (err) {
    setLoading(false);
    console.log("error2", err);
    toast.error("Error", {
      autoClose: 2000,
      position: "top-right",
    });
  }
};

        const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);
    
        
  return (
    <div className='bg-[#9ccee2] '>

         {user ? (user.is_superuser ? <NewAdminNav /> :  <Usernav />) : <NewHomeNav/>}

        <section className='mt-14 mb-10'>
        <div className=" px-[30px] xm:px-[10px] w-[100%] lg:w-[90%] m-auto  rounded ">
      {/* Links for selecting form type */}
      <div className="flex justify-center gap-8 lg:flex-wrap lg:gap-5 items-center">
        
        <button
          className='text-[#2e5775] text-2xl mb-3 font-bold'
        >
          Register Supply Equipments
        </button>
        
      </div>

                  <Link to={'/regShip'} className='px-3  text-[#2e5775]'><i className='fa-solid fa-beat fa-arrow-left '></i> Back</Link>


      {/* Conditional Form Rendering */}
        <form className="bg-white mt-2 rounded w-[100%]">
          <div className="p-5">
            <h1 className="text-black font-bold text-xl">Register Supply Equipments</h1>
          </div>
          <hr className="text-gray-100 w-full" />
          <div className="p-5">
            <label htmlFor="Category" className="font-semibold">
              Category 
            </label>
            <select
                    value={Category}
                    onChange={(e) => setCategory(e.target.value)}
                    className="w-full mt-2 rounded border border-gray-400 p-2 text-[#d1a460]"
                    name="SubCategory"
                    id="SubCategory"
                  >
                    <option disabled value=""> -Select Category-</option>
                    
                    {allSubCategory.length === 0 ? (
                      <option value="" disabled>
                        No subcategory available
                      </option>
                    ) : (
                      allSubCategory.map((itm) => (
                        <option key={itm.id} value={itm.sub_category_name}>
                          {itm.sub_category_name}
                        </option>
                      ))
                    )}
                  </select>

          </div>
          <div className="p-5">
            <label htmlFor="Subject" className="font-semibold">
              Subject 
            </label>
            <input
            value={Subject}
            onChange={(e)=>setSubject(e.target.value)}
              className="w-full mt-2 rounded border border-gray-400 p-2 text-gray-500"
              id="Subject"
            />
           
          </div>
          <div className="p-5">
            <label htmlFor="Description" className="font-semibold">
              Description
            </label>
            <textarea
            value={BriefDescription}
            onChange={(e)=>setBriefDescription(e.target.value)}
              rows={5}
              className="w-full mt-2 rounded border border-gray-400 p-2 text-gray-500"
              id="Description"
            ></textarea>
          </div>

          <div className='p-5 flex gap-16 items-center xm:flex-wrap xm:gap-5'>
                <div className='flex flex-col gap-1 w-[50%] xm:w-[100%]'>
                    <label htmlFor="Email" className='font-semibold'>Email</label>
                    <input value={Email} onChange={(e)=>setEmail(e.target.value)} className='w-full mt-2 rounded border border-gray-400  text-gray-500 p-2' name="" id="Email"  />
                </div>

                <div className='flex flex-col gap-1 w-[50%] xm:w-[100%]'>
                    <label htmlFor="Mobile No" className='font-semibold'>Mobile No</label>
                    <input value={MobileNO} onChange={(e)=>setMobileNO(e.target.value)} className='w-full mt-2 rounded border border-gray-400  text-gray-500 p-2' name="" id="Mobile No"  />
                </div>
                
                </div>

                {/* upoad image */}
              <div className="p-5">
  {/* Previews */}
{selectedImages.length > 0 && (
  <div className="flex gap-4 mb-4 flex-wrap">
    {selectedImages.map((img, index) => (
      <div key={index} className="relative w-28 h-28">
        <img
          src={img.preview}
          alt={`preview ${index}`}
          className="w-full h-full rounded border border-gray-300"
        />
        <button
          onClick={() => removeImage(index)}
          className="absolute top-0 right-0 bg-red-500 text-white text-xs px-1 rounded-bl"
          title="Remove"
        >
          ✕
        </button>
      </div>
    ))}
  </div>
)}


  {/* Upload Field */}
  <label htmlFor="image" className="">
    Upload Images (Max 3 Images)
  </label>
  <input
    type="file"
    onChange={handleImageChange}
    multiple
    accept="image/*"
    className="imageInput w-full mt-2 rounded border border-gray-400 text-gray-500 p-2"
    id="image"
    disabled={selectedImages.length >= 3}
  />
</div>


          <div className="p-4">
            <button 
            onClick={(e)=>handleSubmitEqupment(e)} className="bg-green-600 hover:bg-green-500 text-white px-3 py-2 rounded">
              Submit
            </button>
          </div>
        </form>
    


    </div>
        
        
        </section>
    

    
    {/* Go to Top Button */}
    {isScrolled && (
  <div
    className="fixed bottom-16 right-8 z-50 " // Ensure it's in the right position with high z-index
  >
    <div
      className="back-to-top px-4 hover:bg-[#615d91]"
      onClick={scrollToTop}
    >
      <i className="fa-solid fa-arrow-up text-2xl"></i>
    </div>
  </div>
)}
     
    <NewFooter/>
      
    </div>
  )
}
